import { render } from "./DentalServices.vue?vue&type=template&id=8bde6580"
import script from "./DentalServices.vue?vue&type=script&lang=js"
export * from "./DentalServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__